import { render, staticRenderFns } from "./peopleOperation.vue?vue&type=template&id=3742c900&scoped=true"
import script from "./peopleOperation.vue?vue&type=script&lang=js"
export * from "./peopleOperation.vue?vue&type=script&lang=js"
import style0 from "./peopleOperation.vue?vue&type=style&index=0&id=3742c900&prod&lang=scss&scoped=true"
import style1 from "./peopleOperation.vue?vue&type=style&index=1&id=3742c900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742c900",
  null
  
)

export default component.exports